import parse from "html-react-parser";
import React from "react";

import Typography from "_components/atoms/typography";

import useStyles from "./styles";

const TotalEarningView = ( { title, earning } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.stepFourWrapper }>

			{title && (
				<Typography
					className = { classes.earningDescription }
					color     = "secondary"
					title     = { parse ( title ) }
				/>
			)}

			{( earning !== undefined ) && (
				<Typography
					className = { classes.earningCount }
					title     = { parse ( "&#x20B9;" ) + ` ${ earning }` }
				/>
			)}

		</div>

	);
};

export default TotalEarningView;